let module;
let form;
let inputCodeField;
let errorScreen;
let formScreen;
let successScreen;

function showErrorScreen() {
	changeTitle(errorScreen);
	errorScreen.removeAttribute('hidden');
	successScreen.setAttribute('hidden', true);
	formScreen.setAttribute('hidden', true);
}

function showFormScreen() {
	changeTitle(formScreen);
	errorScreen.setAttribute('hidden', true);
	successScreen.setAttribute('hidden', true);
	formScreen.removeAttribute('hidden');

	inputCodeField.value = '';
	inputCodeField.focus();
}

function showSuccessScreen() {
	changeTitle(successScreen);
	errorScreen.setAttribute('hidden', true);
	formScreen.setAttribute('hidden', true);
	successScreen.removeAttribute('hidden');
}

function changeTitle(screen) {
	const title = screen.querySelector(
		'[js-element~="deviceRegistrationTitle"]'
	).textContent;
	document.title = `${title} - ${window.i18n.product}`;
}

function toggleLoader() {
	const status = formScreen.querySelector(
		"[js-element~='deviceRegistrationStatus']"
	);
	const message = document.createElement('p');
	message.classList.add('visually-hidden');
	message.textContent = 'Bezig';
	status.appendChild(message);

	form.hidden = !form.hidden;
	status.classList.toggle('visually-hidden');
}

async function onSubmitHandler(event) {
	event.preventDefault();

	toggleLoader();

	const data = new FormData(form);
	const payload = {};
	data.forEach((value, key) => (payload[key] = value));

	try {
		const request = await fetch(form.getAttribute('action'), {
			method: form.method,
			headers: {
				'Content-Type': 'application/json',
				'x-csrf-token': window.App.csrfToken,
			},
			body: JSON.stringify(payload),
		});

		if (!request.ok) {
			throw Error('Request was not OK');
		}

		showSuccessScreen();
	} catch {
		showErrorScreen();
	}

	toggleLoader();
}

function retryButtonHandler() {
	showFormScreen();
}

function init() {
	module = document.querySelector('[js-module~="deviceRegistration"]');
	if (!module) return;
	form = module.querySelector('[js-element~="deviceRegistrationForm"]');
	inputCodeField = form.querySelector(
		'[js-element~="deviceRegistrationCodeField"]'
	);
	errorScreen = module.querySelector(
		'[js-element~="deviceRegistrationErrorScreen"]'
	);
	formScreen = module.querySelector(
		'[js-element~="deviceRegistrationFormScreen"]'
	);
	successScreen = module.querySelector(
		'[js-element~="deviceRegistrationSuccessScreen"]'
	);
	form.setAttribute('novalidate', 'true');
	form.addEventListener('submit', onSubmitHandler);
	module
		.querySelector('[js-element~="deviceRegistrationPrimaryButton"]')
		.addEventListener('click', retryButtonHandler);
}

export default {
	init,
};
